import { render, staticRenderFns } from "./UDocuments.vue?vue&type=template&id=092ebb16&"
import script from "./UDocuments.vue?vue&type=script&lang=js&"
export * from "./UDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports